import React,{Fragment,useState,useEffect,useRef,forwardRef} from "react";
import PropTypes from "prop-types";
import './ToggleSwitch.css';
import { renderToStaticMarkup ,renderToString } from 'react-dom/server';
import { flushSync ,hydrate,render} from 'react-dom';
// import { hydrateRoot } from "react-dom/client";
import SweetAlert from 'sweetalert-react';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import * as LocalStorage from "../../utils/localStorageHelper";
import ChooseAddressBarUI from "./ChooseAddressBarUI";
import * as Cart from '../../utils/cartHelper';
// import {hydrateRoot} from 'react-dom/client';
// import { useDispatch } from "react-redux";
import { connect } from 'react-redux';
// import * as UserActions from '../../../actions/userActions';
import * as UserActions from '../../actions/userActions';
/*
Toggle Switch Component
Note: id, checked and onChange are required for ToggleSwitch component to function.
The props name, small, disabled and optionLabels are optional.
Usage: <ToggleSwitch id={id} checked={value} onChange={checked => setValue(checked)}} />
*/

const ToggleSwitch = ({ id, name, checked, onChange, optionLabels, small, disabled,user,props }) => {
  const autocompleteElement = useRef();
  let autoComplete = null;
  let placeChangeListener = null;
  const [active, setActive] = useState("DeliveryToMe");
  const divRef = React.useRef();
  const [userAddresses, setUserAddresses] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [place, setPlace] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showAddressForm, setShowAddressForm] = useState(false);
  useEffect(() => {
    initGoogleAutoSuggest();
  
  }, []);
   useEffect(() => {
    setUserAddresses(user.addresses)
  
  }, [user]);

   useEffect(() => {
    console.log("root useEffect hydrate");
    // document.querySelector("#addAddressDiv")
    // function handlekeydownEvent(event) {
    // console.log();
    // }
    console.log("root divRef",divRef.current);
    let root = document.querySelectorAll('#addAddressDiv');
    console.log("root add",root);
    // let root = document.querySelectorAll('[data-reactroot]');
    // let root = document.querySelector("body > div.sweet-alert.with-close.showSweetAlert.visible");
    if(showAlert){
      console.log("showAlert",showAlert);
    // let rootID3 = document.getElementById('addAddressDiv');
    let rootID3 = document.querySelectorAll('[data-reactroot]');
      console.log("root rootID3",rootID3);
      hydrate(<ChooseAddressBarUI userAddresses={userAddresses?userAddresses:null} showAlert={showAlert} />,rootID3);
      setShowAlert("hghggh");
    }
    // console.log("root",root);
    // if (root && root.length) {

    // // let rootID = document.getElementById('#addAddressDiv');
    // let rootID2 = document.getElementById('app');
    // let rootID = document.querySelector('#addAddressDiv');
    // // let rootID4 = document.querySelector("body > div.sweet-alert.with-close.showSweetAlert.visible > p");
    //   console.log("root flush x",root);
    //   console.log("root rootID",rootID);
    //   console.log("root rootID",divRef.current);
    //   console.log("root rootID2",rootID2);
      
    //   // setTimeout(() => {
    //   // });
    // // root.addEventListener('click', () => alert("Hi user!"))
    // }

   
    
  
  }, [showAlert]);
  
  // useEffect(() => {
  //   // document.querySelector("#addAddressDiv")
  //   function handlekeydownEvent(event) {
  //   console.log();
  //   }
  //   let root = document.querySelector('#addAddressDiv');
  //   console.log("root",root);
  //   if (root) {
        
  //   root.removeEventListener('click', () => alert("Hi user!"))
  //   }
  
  // }, []);

  const initGoogleAutoCompleteService=(inputElement, eventHandler)=> {
    if (!autoComplete) {
        autoComplete = new google.maps.places.Autocomplete(inputElement);
        placeChangeListener = autoComplete.addListener('place_changed', () => {
            let place = autoComplete.getPlace();
            if (place.geometry) {
                eventHandler(place);
            }
        });
    }
}

const initGoogleAutoSuggest=()=> {
  // this.initMap(this.mapElement);
  initGoogleAutoCompleteService(autocompleteElement.current, (place) => {
    setPlace(place);
  });
  // this.initDeliveryPolygons();
}
  const handleClick = (event) => {
    setActive(event.target.id);
    let isGiftDelivery=event.target.id=='SendAsGift'?true:false;
    Cart.modifyCartAttribute(Cart.ATTRIBUTE_GIFT_DELIVERY, { giftDelivery: isGiftDelivery });
 
  }

  const openModalFunc=()=>{
setOpenModal(true);
    Swal.fire({
      title: 'Saved Address',
      // icon: 'info',
      html:renderToStaticMarkup(<ChooseAddressBarUI userAddresses={userAddresses?userAddresses:null} showAlert={showAlert}/>),
      showCloseButton: true,
      // showCancelButton: true,
      confirmButtonColor: '#05AFD6',
      focusConfirm: false,
      confirmButtonText:
        'Done',
      confirmButtonAriaLabel: 'Done!',
      // cancelButtonText:
      //   '<i class="fa fa-thumbs-down"></i>',
      // cancelButtonAriaLabel: 'Thumbs down'
      // showCloseButton: true,
      // showCancelButton: true,
      // focusConfirm: false,
      // confirmButtonText:
      //   '<i class="fa fa-thumbs-up"></i> Great!',
      // confirmButtonAriaLabel: 'Thumbs up, great!',
      // cancelButtonText:
      //   '<i class="fa fa-thumbs-down"></i>',
      // cancelButtonAriaLabel: 'Thumbs down'
    })
  }
  useEffect(() => {
    if(openModal){

    let swal2 = document.getElementById('swal2-html-container');
    
    console.log("root hello",swal2);
    hydrate(<ChooseAddressBarUI focusHandler={()=>setOpenModal(false)} userAddresses={userAddresses?userAddresses:null} showAlert={showAlert} googleAddress={autocompleteElement} props={props}/>,swal2);
    setOpenModal(false);
  }else{
    console.log("root no hello");
  }
  
  }, [openModal]);
  const openAddressSelectModal=()=>{
setShowAlert(true);
// let root = document.querySelectorAll('[data-reactroot]');
// console.log("root after active",root);
// if(root.length){
//   console.log("root.len",root.length);
//   flushSync(() => {
//     hydrate(root, ChooseAddressBarUI);
//   });
// }
  }
  const swalParams= {
    title: "Product added to cart successfully.",
    type: "success",
    showConfirmButton: false
  }
  console.log("ghh",user);
  
  return (
    <div className={`toggle-wrapper mx-auto`}>
      <SweetAlert
          customClass={"with-close"}
          show={false}
          title="Address"
          text="Add your address"
          type="input"
          inputType="text"
          inputPlaceholder="Enter Address"
          // inputValue={autocompleteElement}
          showCancelButton
          confirmButtonColor="#05afd6"
          cancelButtonText={"Resend"}
          confirmButtonText={'Submit'}
          onOutsideClick={() => setShowAddressForm(false)}
          
          onConfirm={(inputValue) => {
            

      
            if (inputValue === undefined || inputValue === null || inputValue === "") {
      swal.showInputError('You need to write something!');
      return;
    }
            // this.checkOtp(inputValue);
            return;
          }}
          onEscapeKey={() => this.setState({ show: false })}
         
        />
      
      <SweetAlert 
      
      customClass={"with-close"} 
      showCancelButton cancelButtonText={"x"} 
      onCancel={() => setShowAlert(false)} 
      show={showAlert} 
      html
      // text={document.querySelectorAll("[data-custom-class='with-close useraddress']")[0]?hydrate(renderToString(<ChooseAddressBarUI userAddresses={userAddresses?userAddresses:null} />),document.querySelectorAll("[data-custom-class='with-close useraddress']")[0]):<div>yo yo</div>}
      // text={renderToString(<ChooseAddressBarUI userAddresses={userAddresses?userAddresses:null} showAlert={showAlert} />)}
      text={renderToString(<ChooseAddressBarUI  userAddresses={userAddresses?userAddresses:null} showAlert={showAlert}  props={props}/>)}
      title="Address"
      // text="Enter your OTP"
      // type="input"
      // inputType="number"
      // inputPlaceholder="Enter OTP"
      
      confirmButtonColor="#05afd6"
      // cancelButtonText={"Resend"}
      // confirmButtonText={'Submit OTP'}

      onConfirm={(inputValue) => {
            

      
        if (inputValue === undefined || inputValue === null || inputValue === "") {
  swal.showInputError('You need to write something!');
  return;
}
        checkOtp(inputValue);
        return;
      }}
      onEscapeKey={() => this.setState({ show: false })}
      
      
      
      />
        
      <div className="d-flex justify-content-between">
    <button
      key={1}
      className={` normal-tag  ${active === "DeliveryToMe" ? "active-tag" : undefined}`}
      id={"DeliveryToMe"}
      onClick={handleClick}
    >
      Delivery to me
    </button>

     <button
     key={2}
     className={` normal-tag  ${active === "SendAsGift" ? "active-tag" : undefined}`}
     id={"SendAsGift"}
     onClick={handleClick}
   >
    Send a gift
   </button>
   </div>
   <div className="divider"></div>
  <div className="d-flex mx-auto">
  {/* <GoogleAddressDiv /> */}
      {/* <input placeholder="Enter address..." className="form-control" ref={autocompleteElement}/> */}
      {/* <div onClick={openAddressSelectModal}>Select address</div> */}

      <div className="px-4" onClick={openModalFunc}><p className="text-small"><span ><svg role="img" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="15" height="20"><title>location</title><path  style={{fill: 'red'}} d="M8.06563 0C3.60517 0 0 3.43824 0 7.69231C0 8.66926 0.299103 9.9101 0.646058 10.7692L8.07572 24L15.5054 10.7692C15.8543 9.90978 16.1514 8.66969 16.1514 7.69231C16.1514 3.43824 12.5261 0 8.06563 0ZM8.06563 3.69231C10.3851 3.69231 12.2751 5.4802 12.2751 7.69231C12.2751 9.90442 10.3851 11.6923 8.06563 11.6923C5.74619 11.6923 3.87635 9.90442 3.87635 7.69231C3.87635 5.4802 5.74619 3.69231 8.06563 3.69231Z"></path></svg></span>
  {LocalStorage.get('delivery_address')?LocalStorage.get('delivery_address').loc:'Select address'}</p></div>
      {/* {place?<div className="value">{place.formatted_address}</div>:null} */}
            </div>
</div>
    );
}

// const wrapper = document.createElement("div");
// render(<ChooseAddressBarUI />, wrapper);
export default ToggleSwitch;


// WEBPACK FOOTER //
// ./src/containers/commons/ToggleSwitch.js